module.exports = __webpack_public_path__ + "static/media/managePaymentLink.9876c533.svg";